import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router";
import { ConfirmRedirect } from "Routes/ConfirmRedirect";
import { AppUser } from "State/Auth/AuthReducer";
import { Resources, useResource } from "Translations/Resources";
import { isNoU } from "Utils/ObjectUtils";

interface AuthenticatedRouteProps extends RouteProps {
  user: AppUser | null;
}

const AuthenticatedRoute: React.FunctionComponent<AuthenticatedRouteProps> = ({
  children,
  user,
  ...rest
}) => {
  const { t } = useResource();
  const isAuthenticated =
    !isNoU(user) && !isNoU(user?.login) && user?.login !== "";

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          <>
            <ConfirmRedirect />
            {children}
          </>
        ) : (
          <Redirect
            to={{
              pathname: `/${t(Resources.Routes.Login)}`,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export { AuthenticatedRoute };
